import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/ManufacturerPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined, } from "@ant-design/icons";
import { ManufacturerForm } from "@/components/ManufacturerForm";
export const ManufacturerPage = observer(() => {
    const navigate = useNavigate();
    const { manufacturerId } = useParams();
    const { singleManufacturerStore: store, authStore: { userRole }, } = getRootStore();
    const { manufacturer, loading } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(manufacturerId);
        return () => {
            store.clearManufacturerData();
        };
    }, [manufacturerId]);
    const handleBack = () => {
        navigate("/manufacturers");
    };
    const handleSave = async (values) => {
        const isNewManufacturer = !manufacturer;
        store.saveManufacturer(values).then((savedManufacturer) => {
            if (savedManufacturer) {
                if (isNewManufacturer) {
                    message.success("Производитель успешно создан");
                    navigate(`/manufacturers/${savedManufacturer.id}`);
                }
                else {
                    message.success("Производитель успешно обновлен");
                }
            }
        });
    };
    const handleDeleteManufacturer = () => {
        if (!manufacturer)
            return;
        Modal.confirm({
            title: "Удаление производителя",
            content: "Вы уверены, что хотите удалить этого производителя?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteManufacturer(manufacturer.id);
                message.success("Производитель успешно удален");
                navigate("/manufacturers");
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(ManufacturerForm, { manufacturer: manufacturer, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: canDelete && manufacturer ? (_jsx(Button, { type: "default", danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteManufacturer, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) : undefined })] }));
});
export default ManufacturerPage;
